export const formatMoney = (amount) => {
    return (amount ?? 0).toLocaleString("EN-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
